import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation AcceptRenewalUpsell(
    $signatureContact: InputRenewalUpsellContact
    $seats: Int
    $productsUpdated: [InputRenewalProduct]
    $productsAdded: [InputRenewalProduct]
    $productsRemoved: [InputRenewalProduct]
    $platformBillingPeriod: BillingPeriod
  ) {
    acceptRenewalUpsell(
      signatureContact: $signatureContact
      seats: $seats
      productsUpdated: $productsUpdated
      productsAdded: $productsAdded
      productsRemoved: $productsRemoved
      platformBillingPeriod: $platformBillingPeriod
    )
  }
`

export const acceptRenewalUpsellKey = getQueryNames(query)[0]

export default query
